// website_episode_listening_apps.js
// Episode Listening Apps Links component for Website Episode Settings page

import { validate_link } from '../prefix_tracking_links/link_validations';
import { dispatchDistributionUpdateToast } from '../shared/distribution_update_feedback';

// Make validate_link available globally for Alpine template expressions
window.validate_link = validate_link;

document.addEventListener('alpine:init', () => {
    const template = document.getElementById('website-episode-listening-apps-data');
    if (!template) return;

    Alpine.data('websiteEpisodeListeningAppsSetup', () => {
        const distribution_links = JSON.parse(template.dataset.distributionLinks || '{}');
        const all_distribution_platforms = JSON.parse(template.dataset.allDistributionPlatforms || '[]');
        const update_url = template.dataset.updateUrl;
        const episode_id = template.dataset.episodeId;

        return {
            distribution_links: distribution_links,
            all_distribution_platforms: all_distribution_platforms,
            distribution_links_truth: [],
            add_more_options: [],
            redirect_only: false,
            selected_youtube_url: false,
            linkSelector: null,
            selectorVisible: false,
            distributionLinkSelector: undefined,
            existing_links_to_delete: [],
            error_text: "",
            save_button_text: "Save",

            init() {
                this.linkSelector = document.querySelector("#link-selector");
                this.create_arrays();
                
                this.$watch('distribution_links_truth', (newValue) => {
                    this.selected_youtube_url = newValue.some(link => link.pattern === 'youtube_url');
                });
            },

            create_arrays() {
                for (let i = 0; i < this.all_distribution_platforms.length; i++) {
                    if (this.distribution_links.hasOwnProperty(this.all_distribution_platforms[i].pattern) && 
                        this.distribution_links[this.all_distribution_platforms[i].pattern] !== "") {
                        this.distribution_links_truth.push({
                            name: this.all_distribution_platforms[i].name,
                            pattern: this.all_distribution_platforms[i].pattern,
                            url: this.distribution_links[this.all_distribution_platforms[i].pattern]
                        });
                    } else {
                        this.add_more_options.push({
                            name: this.all_distribution_platforms[i].name,
                            pattern: this.all_distribution_platforms[i].pattern
                        });
                    }
                }

                this.build_options_list();
                if (this.distribution_links_truth.length > 0) {
                    this.create_link_elements();
                } else {
                    this.create_empty_link_elements();
                }
            },

            create_link_elements() {
                const linksContainer = document.querySelector("#links-container");
                linksContainer.innerHTML = '';
                
                for (let i = 0; i < this.distribution_links_truth.length; i++) {
                    const link = this.distribution_links_truth[i];
                    if (link.url !== "") {
                        linksContainer.innerHTML += this.getStandardLinkHTML(link);
                    }
                }
            },

            create_empty_link_elements() {
                const linksContainer = document.querySelector("#links-container");
                linksContainer.innerHTML = '';

                const default_items = [
                    {name: "Apple Podcasts", pattern: "itunes_url", url: ""}, 
                    {name: "Spotify", pattern: "spotify_url", url: ""}, 
                    {name: "YouTube Music", pattern: "youtube_music_url", url: ""}
                ];

                for (let i = 0; i < default_items.length; i++) {
                    const link = default_items[i];
                    this.distribution_links_truth.push({
                        name: link.name,
                        pattern: link.pattern,
                        url: ""
                    });
                    linksContainer.innerHTML += this.getEmptyLinkHTML(link);
                    this.remove_from_options_list(link.pattern);
                }
            },

            getStandardLinkHTML(link) {
                return `
                <div id="${link.pattern}" class="border rounded p-4 ql-link-el">
                  <div class="flex space-x-4 items-center">
                    <div class="w-12 h-12">
                      <img src="https://files.cohostpodcasting.com/static/${link.pattern}_image.svg" alt="${link.name} Logo">
                    </div>
                    <div class="flex flex-col flex-1 space-y-2">
                      <div class="font-bold text-sm">${link.name}</div>
                      <div class="flex space-x-2 items-center">
                        <div class="relative rounded-md shadow-sm w-full"
                          x-data="{ url: '${link.url}', is_valid: validate_link('${link.pattern}', '${link.url}') }"
                          x-init="$watch('url', value => {
                              is_valid = value === '' ? null : validate_link('${link.pattern}', value)
                          })"
                        >
                          <input
                            x-model="url"
                            id="${link.pattern}-url"
                            autocomplete="off"
                            type="text"
                            class="block pr-10 h-9 w-full rounded border-gray-300 text-sm"
                            placeholder="Copy and paste your ${link.name} show link" value="${link.url}">
                          <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" x-show="is_valid === true">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                            </svg>
                          </div>
                          <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" x-show="is_valid === false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#DC2626"/>
                              <path d="M15 9L9 15M9 9l6 6" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </div>
                        </div>
                        <svg class="cursor-pointer" @click="delete_link('${link.name}','${link.pattern}')" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3 6H5H21" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M10 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>`;
            },

            getEmptyLinkHTML(link) {
                return `
                <div id="${link.pattern}" class="border rounded p-4 ql-link-el">
                  <div class="flex space-x-4 items-center">
                    <div class="w-12 h-12">
                      <img src="https://files.cohostpodcasting.com/static/${link.pattern}_image.svg" alt="${link.name} Logo">
                    </div>
                    <div class="flex flex-col flex-1 space-y-2">
                      <div class="font-bold text-sm">${link.name}</div>
                      <div class="flex space-x-2 items-center">
                        <div class="relative rounded-md shadow-sm w-full"
                             x-data="{ url: '', is_valid: null }"
                             x-init="$watch('url', value => {
                               is_valid = value === '' ? null : validate_link('${link.pattern}', value)
                             })">
                          <input
                            x-model="url"
                            id="${link.pattern}-url"
                            autocomplete="off"
                            type="text"
                            class="block pr-10 h-9 w-full rounded border-gray-300 text-sm"
                            placeholder="Copy and paste your ${link.name} show link"
                          >
                          <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" x-show="is_valid === true">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                            </svg>
                          </div>
                          <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" x-show="is_valid === false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#DC2626"/>
                              <path d="M15 9L9 15M9 9l6 6" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </div>
                        </div>
                        <svg class="cursor-pointer" @click="delete_link('${link.name}','${link.pattern}')" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path d="M3 6H5H21" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M8 6V4C8 3.47 8.21 2.96 8.59 2.59C8.96 2.21 9.47 2 10 2H14C14.53 2 15.04 2.21 15.41 2.59C15.79 2.96 16 3.47 16 4V6M19 6V20C19 20.53 18.79 21.04 18.41 21.41C18.04 21.79 17.53 22 17 22H7C6.47 22 5.96 21.79 5.59 21.41C5.21 21.04 5 20.53 5 20V6H19Z"
                                stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14 11V17M10 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>`;
            },

            delete_link(name, pattern) {
                this.clear_error_message();
                const el = document.querySelector(`#${pattern}`);
                if (el) el.remove();

                for (let i = 0; i < this.distribution_links_truth.length; i++) {
                    if (this.distribution_links_truth[i].pattern === pattern) {
                        this.distribution_links_truth.splice(i, 1);
                        break;
                    }
                }

                if (this.distribution_links.hasOwnProperty(pattern) && 
                    !this.existing_links_to_delete.includes(pattern)) {
                    this.existing_links_to_delete.push(pattern);
                }

                this.add_to_options_list(name, pattern);
            },

            add_to_options_list(name, pattern) {
                this.add_more_options.push({
                    name: name,
                    pattern: pattern
                });
                this.build_options_list();
            },

            remove_from_options_list(pattern) {
                for (let i = 0; i < this.add_more_options.length; i++) {
                    if (this.add_more_options[i].pattern === pattern) {
                        this.add_more_options.splice(i, 1);
                        break;
                    }
                }
                this.build_options_list();
            },

            build_options_list() {
                const linkSelector = document.querySelector("#link-selector");
                if (!linkSelector) return;

                linkSelector.innerHTML = `<option value="">Select a listening app</option>`;
                for (let i = 0; i < this.add_more_options.length; i++) {
                    const option = this.add_more_options[i];
                    linkSelector.innerHTML += `<option value="${option.pattern}">${option.name}</option>`;
                }
                this.sync_options();
            },

            handle_add_more() {
                const linkElements = document.querySelectorAll(".ql-link-el");
                for (let i = 0; i < linkElements.length; i++) {
                    const linkElement = linkElements[i];
                    const pattern = linkElement.id;
                    const urlInput = document.querySelector(`#${pattern}-url`);
                    if (urlInput) {
                        const url = urlInput.value;
                        if (url && validate_link(pattern, url) === false) {
                            this.set_error_message(pattern);
                            return;
                        }
                    }
                }

                const linkSelector = document.querySelector("#link-selector");
                if (!linkSelector) return;

                const handleItemAdd = (value, item) => {
                    this.distributionLinkSelector.clear();
                    this.distributionLinkSelector.destroy();
                    this.selectorVisible = false;
                    linkSelector.classList.add("hidden");
                    this.create_link_element(value, item);
                };

                const handleBlur = () => {
                    this.distributionLinkSelector.clear();
                    this.distributionLinkSelector.destroy();
                    this.selectorVisible = false;
                    linkSelector.classList.add("hidden");
                };

                linkSelector.classList.remove("hidden");
                this.distributionLinkSelector = new TomSelect("#link-selector", {create: false});
                this.selectorVisible = true;
                this.distributionLinkSelector.on("item_add", handleItemAdd);
                this.distributionLinkSelector.on("blur", handleBlur);
            },

            sync_options() {
                if (this.selectorVisible && this.distributionLinkSelector) {
                    this.distributionLinkSelector.sync();
                }
            },

            create_link_element(value, item) {
                const linksContainer = document.querySelector("#links-container");
                const newDiv = document.createElement("div");
                linksContainer.appendChild(newDiv);

                newDiv.outerHTML = this.getNewStandardLinkHTML(value, item);

                this.remove_from_options_list(value);
                this.distribution_links_truth.push({
                    name: item.textContent,
                    pattern: value,
                    url: ""
                });
            },

            getNewStandardLinkHTML(value, item) {
                return `
                <div id="${value}" class="border rounded p-4 ql-link-el">
                  <div class="flex space-x-4 items-center">
                    <div class="w-12 h-12">
                      <img src="https://files.cohostpodcasting.com/static/${value}_image.svg" alt="${item.textContent} Logo">
                    </div>
                    <div class="flex flex-col flex-1 space-y-2">
                      <div class="font-bold text-sm">${item.textContent}</div>
                      <div class="flex space-x-2 items-center">
                        <div class="relative rounded-md shadow-sm w-full"
                             x-data="{ url: '', is_valid: null }"
                             x-init="$watch('url', value => {
                               is_valid = value === '' ? null : validate_link('${value}', value)
                             })">
                          <input
                            x-model="url"
                            id="${value}-url"
                            type="text"
                            class="block pr-10 h-9 w-full rounded border-gray-300 text-sm"
                            placeholder="Copy and paste your ${item.textContent} show link"
                          >
                          <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" x-show="is_valid === true">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M12 22C6.47967 21.994 2.00606 17.5204 2 12V11.8C2.10993 6.30455 6.63459 1.92797 12.1307 2.0009C17.6268 2.07382 22.0337 6.5689 21.9978 12.0654C21.9619 17.5618 17.4966 21.9989 12 22ZM7.41 11.59L6 13L10 17L18 9.00002L16.59 7.58002L10 14.17L7.41 11.59Z" fill="#059669"/>
                            </svg>
                          </div>
                          <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" x-show="is_valid === false">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" fill="#DC2626"/>
                              <path d="M15 9L9 15M9 9l6 6" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </div>
                        </div>
                        <svg class="cursor-pointer" @click="delete_link('${item.textContent}','${value}')" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path d="M3 6H5H21" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M8 6V4C8 3.47 8.21 2.96 8.59 2.59C8.96 2.21 9.47 2 10 2H14C14.53 2 15.04 2.21 15.41 2.59C15.79 2.96 16 3.47 16 4V6M19 6V20C19 20.53 18.79 21.04 18.41 21.41C18.04 21.79 17.53 22 17 22H7C6.47 22 5.96 21.79 5.59 21.41C5.21 21.04 5 20.53 5 20V6H19Z"
                                stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14 11V17M10 11V17" stroke="#8B5CF6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>`;
            },

            submit() {
                const linkElements = document.querySelectorAll(".ql-link-el");
                let data = {};

                for (let i = 0; i < linkElements.length; i++) {
                    const linkElement = linkElements[i];
                    const pattern = linkElement.id;
                    const urlInput = document.querySelector(`#${pattern}-url`);
                    if (urlInput) {
                        const url = urlInput.value;
                        data[pattern] = url;

                        if (url && validate_link(pattern, url) === false) {
                            this.set_error_message(pattern);
                            return;
                        }
                    }
                }

                for (let i = 0; i < this.existing_links_to_delete.length; i++) {
                    if (!data.hasOwnProperty(this.existing_links_to_delete[i])) {
                        data[this.existing_links_to_delete[i]] = "";
                    }
                }

                this.save_button_text = "Saving...";

                fetch(update_url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        authenticity_token: document.querySelector('meta[name="csrf-token"]').content,
                        distribution_links: data,
                        episode_id: episode_id
                    })
                }).then(async response => {
                    const payload = await response.json().catch(() => ({}));

                    if (response.ok) {
                        this.save_button_text = "Saved!";
                        dispatchDistributionUpdateToast(payload, 'Listening app links saved.');
                        setTimeout(() => {
                            this.save_button_text = "Save";
                        }, 3000);
                    } else {
                        this.save_button_text = "Error";
                        setTimeout(() => {
                            this.save_button_text = "Save";
                        }, 3000);
                    }
                }).catch(() => {
                    this.save_button_text = "Error";
                    setTimeout(() => {
                        this.save_button_text = "Save";
                    }, 3000);
                });
            },

            set_error_message(pattern) {
                for (let i = 0; i < this.all_distribution_platforms.length; i++) {
                    const item = this.all_distribution_platforms[i];
                    if (item.pattern === pattern) {
                        this.error_text = `Please enter a valid ${item.name} link.`;
                        return;
                    }
                }
            },

            clear_error_message() {
                this.error_text = "";
            }
        };
    });
});
